/**
 * Convert SupportPal colour scheme to an array usable by tinymce.
 *
 * @return {[]}
 */
function colourSchemeMap()
{
  var theme = typeof spCssVarThemes === "undefined" ? {} : spCssVarThemes,
    light = theme.light || {},
    colours = [];

  for (var color in light) {
    colours.push(light[color]);
    colours.push(light[color]);
  }

  return colours;
}

export {colourSchemeMap};
